<template>
  <div class="section application-submission">
    <div class="section-title" :class="{ 'border-bottom': showOperate }">
      <base-section-title>
        <div class="flex">
          <span class="m-r-10">{{ applicationTitle }}</span>
          <we-chat-bind-dialog
            desc-text="关注微信公众号，获取项目最新动态"
            :show-background="true"
          />
        </div>

        <template v-slot:right-tool>
          <slot name="titleAfter"></slot>
        </template>
      </base-section-title>
    </div>

    <div v-if="auditResult.result === 'notStarted'" class="section-content">
      <apply-content-lock title="报名尚未开始" />
    </div>

    <div v-else class="section-content">
      <!----审核结果展示----->
      <div
        v-if="submitAudit && resultTranslate.value && resultTranslate.text"
        :class="`audit audit-${resultTranslate.text}`"
      >
        <div class="audit-status flex">
          <i
            :class="
              `el-icon-${resultTranslate.icon} text-${resultTranslate.text}`
            "
          ></i>
          <strong>{{ resultTranslate.supplierLabel || '' }}</strong>
        </div>
        <div
          v-if="auditResult.result === auditStatusDict.NOT_PASSED.alias"
          class="audit-content"
        >
          <span>审核理由：{{ defaultAuditResult.opinion }}</span>
        </div>
        <div
          v-else-if="auditResult.result === auditStatusDict.PASSED.alias"
          class="audit-content"
        >
          你所提交的信息已经审核通过，请及时跟进申请状况。
        </div>
        <div v-else class="audit-content">
          你所提交的信息正在审核，请耐心等待审核结果。
        </div>
      </div>

      <base-form-item-title
        title="联系人信息"
        :required="false"
        style="padding: 0"
        :show-bottom-border="false"
      />

      <!-----表单展示----->
      <el-form
        v-if="showOperate"
        ref="contactForm"
        label-width="120px"
        :model="form"
        :rules="rules"
        label-suffix="："
      >
        <el-form-item label="企业名称">
          <div>{{ form.companyName }}</div>
        </el-form-item>
        <el-row :gutter="50" style="width: 100%">
          <el-col :span="8">
            <el-form-item label="联系人姓名" prop="contactUserName">
              <el-input
                v-model="form.contactUserName"
                placeholder="请输入联系人姓名"
                maxlength="20"
                show-word-limit
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人手机" prop="contactUserPhone">
              <el-input
                v-model="form.contactUserPhone"
                placeholder="请输入联系人手机"
                maxlength="11"
                show-word-limit
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人邮箱" prop="contactUserEmail">
              <el-input
                v-model="form.contactUserEmail"
                placeholder="请输入联系人邮箱"
                maxlength="50"
                show-word-limit
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!---详情时候的展示---->
      <ant-descriptions
        v-if="!showOperate"
        :info="form"
        :option="contactOptions"
        :el-attrs="{
          column: 3,
          labelStyle: {
            whiteSpace: 'nowrap'
          }
        }"
      />

      <slot name="underContact" :data="{ showOperate: showOperate }"></slot>

      <div v-if="showRequireList">
        <base-form-item-title
          style="padding: 0"
          title="证件要求"
          :required="false"
          class="base-form-item-title"
          :show-bottom-border="false"
        />
        <jczh-table-content
          :data="certificateList"
          :option="certificateListOption"
        >
          <template v-slot:uploadStatus="{ row }">
            <el-tag :type="row.certAttachmentId ? 'success' : 'info'">
              {{ row.certAttachmentId ? '已上传' : '未上传' }}
            </el-tag>
          </template>
          <template v-slot:last>
            <el-table-column label="操作" min-width="120px" align="center">
              <template slot-scope="{ row }">
                <el-button
                  v-if="showOperate"
                  type="text"
                  @click="uploadCertificate(row)"
                >
                  {{ row.certAttachmentId ? '重新上传' : '上传证件' }}
                </el-button>
                <div v-else class="flex-align__around" style="height:16px">
                  <upload
                    :props-data="{
                      uploadMode: 'fileId',
                      fileIdBefore: row.certAttachmentId,
                      disabled: true,
                      multiple: false,
                      fileListHiddenControl: {
                        hiddenUploadBtn: true,
                        hiddenFileName: true
                      }
                    }"
                  />
                </div>
              </template>
            </el-table-column>
          </template>
        </jczh-table-content>

        <upload-certificate-dialog
          ref="certificateDialog"
          @refresh="handleCertificateDialogConfirm"
        />
      </div>

      <div v-if="otherRequireList.length > 0">
        <base-form-item-title
          style="padding: 0"
          title="其他材料要求"
          :required="false"
          class="base-form-item-title"
          :show-bottom-border="false"
        />
        <other-material-requirements
          ref="otherRequire"
          :mode="showOperate ? 'supplier-edit' : 'supplier-detail'"
          :table.sync="otherMaterialRequireList"
          :biz-type="bizType"
          :upload-mode="uploadMode"
        />
      </div>

      <slot name="underInfo"></slot>

      <div v-if="needAttachmentReview">
        <base-form-item-title
          :title="attachmentTitle"
          style="padding: 0"
          :required="false"
          :show-bottom-border="false"
        />
        <el-form
          ref="fileForm"
          :model="form"
          :rules="rules"
          :label-width="showOperate ? '120px' : ''"
          label-suffix="："
          class="detail-content-width"
          :class="{ 'detail-form': !showOperate }"
        >
          <el-form-item v-if="signUpCheckRemarks" label="备注说明">
            <div>{{ signUpCheckRemarks }}</div>
          </el-form-item>
          <el-form-item
            label="上传附件"
            :prop="needValidateSignAttachment ? 'attachmentGroupId' : ''"
          >
            <div v-if="!showOperate && !form.attachmentGroupId">-</div>

            <upload
              v-else
              ref="uploadFile"
              :file-id-before.sync="form.attachmentGroupId"
              :group-id-before.sync="form.attachmentGroupId"
              :props-data="{
                uploadMode: uploadMode,
                bizType: bizType,
                attachmentType: 'sign_up_attachment',
                limit: 10,
                disabled: !showOperate
              }"
            >
              <span slot="tip">
                支持：rar .zip .doc .docx .pdf
                .jpg等，单个文件最大200M，最多上传10个
              </span>
            </upload>
          </el-form-item>
        </el-form>
      </div>

      <slot name="auditContent"></slot>

      <el-form v-if="showOperate">
        <el-form-item class="operator-line">
          <el-button type="primary" style="width: 120px" @click="submit">
            {{ submitLabel }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// 组件
import BaseFormItemTitle from '@/components/common/BaseFormItemTitle'
import Upload from '@/components/common/Upload'
import ApplyContentLock from '@/components/common/ApplyContentLock'
import UploadCertificateDialog from '@/components/common/UploadCertificateDialog'
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import OtherMaterialRequirements from '@/components/common/OtherMaterialRequirements/OtherMaterialRequirements'
import AntDescriptions from '@/components/common/ant-design/AntDescriptions'
import WeChatBindDialog from '@/components/common/WeChatBindDialog'

// 数据字典
import {
  auditStatusDict,
  otherMaterialTypeDict,
  purchaseAllTypeDict
} from '@/dictionary/project/common'

// 工具函数
import { cloneDeep } from 'lodash'
import { mapState } from 'vuex'
import { formValid } from 'jczh-ui'

// api接口
import {
  addCertificateApi,
  getCertificateDetailApi,
  updateCertificateApi
} from '@/api/company/v1'
import { getDeviceIPApi } from '@/api/platform'
import { Modal } from 'ant-design-vue'
import { getUnpaidChargeListApi } from '@/api/company'

export default {
  name: 'ApplicationSubmission',

  components: {
    WeChatBindDialog,
    Upload,
    BaseFormItemTitle,
    ApplyContentLock,
    UploadCertificateDialog,
    BaseSectionTitle,
    OtherMaterialRequirements,
    AntDescriptions
  },

  props: {
    applicationTitle: {
      type: String,
      default: '投标申请'
    },

    // 资格审查附件上传的业务类型
    bizType: {
      type: String,
      default: ''
    },

    // 报名审核备注信息
    signUpCheckRemarks: {
      type: String,
      default: ''
    },

    // 审核信息
    auditInfo: {
      type: Object,
      default: () => {
        return {
          companyName: '',
          contactUserName: '',
          contactUserPhone: '',
          contactUserEmail: '',
          attachmentGroupId: ''
        }
      }
    },

    // 是否需要附件审核
    needAttachmentReview: {
      type: Boolean,
      default: false
    },

    // 审核结果
    auditResult: {
      type: Object,
      default: () => {
        return {
          result: '',
          opinion: ''
        }
      }
    },

    attachmentTitle: {
      type: String,
      default: '申请资料'
    },

    // 停止报名操作
    stopApply: {
      type: Boolean,
      default: false
    },

    // 证件要求列表
    certRequireList: {
      type: Array,
      default: () => []
    },

    // 其他材料要求列表
    otherRequireList: {
      type: Array,
      default: () => []
    },

    needAttachment: {
      type: Boolean,
      default: true
    },

    uploadMode: {
      type: String,
      default: 'groupId'
    },

    // 是否提交审核
    submitAudit: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      // 数据字典
      auditStatusDict,

      form: {
        companyName: '',
        contactUserName: '',
        contactUserPhone: '',
        contactUserEmail: '',
        attachmentGroupId: ''
      },
      rules: {
        contactUserName: {
          required: true,
          message: '请输入联系人姓名',
          trigger: ['blur', 'change']
        },
        contactUserPhone: [
          {
            required: true,
            message: '请输入联系人电话',
            trigger: ['blur', 'change']
          },
          {
            pattern: formValid.mobileRegular.pattern,
            message: '请输入正确的11位手机号',
            trigger: 'blur'
          }
        ],
        contactUserEmail: [
          {
            required: true,
            message: '请输入联系人邮箱',
            trigger: ['blur', 'change']
          },
          {
            pattern: formValid.emailRegular.pattern,
            message: '请输入格式正确的邮箱地址',
            trigger: 'blur'
          }
        ],
        attachmentGroupId: {
          required: true,
          message: '请上传附件文件',
          trigger: ['blur', 'change']
        }
      },
      certificateList: [],
      // 证件要求
      certificateListOption: [
        {
          label: '证件名称',
          prop: 'certName',
          minWidth: 200
        },
        {
          label: '上传状态',
          slotName: 'uploadStatus',
          minWidth: 100
        }
      ],

      // 其他材料要求
      otherMaterialRequireList: [],

      contactOptions: [
        { label: '企业名称', prop: 'companyName', elAttrs: { span: 3 } },
        { label: '联系人姓名', prop: 'contactUserName' },
        { label: '联系人手机', prop: 'contactUserPhone' },
        { label: '联系人邮箱', prop: 'contactUserEmail' }
      ]
    }
  },

  computed: {
    ...mapState('company', ['companyName']),
    ...mapState('user', [
      'mobile',
      'employeeName',
      'employeeEmail',
      'employeeId'
    ]),

    defaultAuditResult() {
      return {
        result: this.auditResult.result || '',
        opinion: this.auditResult.opinion || ''
      }
    },

    // 申请资料的附件是否必填
    needValidateSignAttachment() {
      if (!this.showOperate) return false
      else if (this.showRequireList || this.otherRequireList.length) {
        return false
      }
      return true
    },

    showOperate() {
      const { PENDING, PASSED, TIME_OUT } = auditStatusDict
      const tempTypes = [PENDING.alias, PASSED.alias, TIME_OUT.alias]
      return (
        tempTypes.indexOf(this.defaultAuditResult.result) < 0 && !this.stopApply
      )
    },

    submitLabel() {
      return this.defaultAuditResult.result === auditStatusDict.NOT_PASSED.alias
        ? '重新提交'
        : `${this.submitAudit ? '提交' : '下一步'}`
    },

    resultTranslate() {
      // 目前主要是为邀请项目，做特殊处理，避免“审核通过”的字眼出现
      const temp =
        auditStatusDict.array.find(
          value => value.alias === this.defaultAuditResult.result
        ) || {}

      // if (temp.value === auditStatusDict.PASSED.value) {
      //   temp.label = '通过'
      // }

      return temp
    },

    showRequireList() {
      return this.certRequireList.length > 0
    }
  },

  watch: {
    auditInfo: {
      handler: function(val) {
        this.form.companyName = this.companyName
        this.form.contactUserName = val.contactUserName || this.employeeName
        this.form.contactUserPhone = val.contactUserPhone || this.mobile
        this.form.contactUserEmail = val.contactUserEmail || this.employeeEmail
        this.form.attachmentGroupId = val.attachmentGroupId || ''
      },
      immediate: true
    },

    certRequireList: {
      handler: function(val) {
        this.certificateList = cloneDeep(val) || []
      },
      deep: true,
      immediate: true
    },

    otherRequireList: {
      handler: function(val) {
        this.otherMaterialRequireList = cloneDeep(val)
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    /**
     * 上传有分类的证件
     */
    async uploadCertificate(row) {
      const obj = {
        name: row.certName,
        fileId: row.certAttachmentId,
        id: row.certClassifyId
      }
      if (obj.fileId) {
        obj.expireTime = await this.getCertDetail(row.certClassifyId)
      }

      const submitApi = row.certAttachmentId
        ? updateCertificateApi
        : addCertificateApi
      this.$refs.certificateDialog.open(obj, submitApi)
    },

    /**
     * 获取证书详情
     */
    async getCertDetail(data) {
      try {
        const _data = await getCertificateDetailApi({
          certificateCategoryId: data
        })
        return _data.data.expireTime
      } catch (err) {
        this.$message.error(err?.message)
      }
    },

    handleCertificateDialogConfirm(data) {
      this.$emit('refreshRequireList', data)
    },

    // 表单校验
    async formValidate() {
      try {
        // 默认包含联系人信息表单校验
        const validateArray = [this.$refs.contactForm.validate()]
        if (this.needAttachmentReview) {
          // 添加资格审查表单校验
          validateArray.push(this.$refs.fileForm.validate())
        }
        // 添加其他材料要求校验
        if (this.$refs.otherRequire) {
          validateArray.push(this.$refs.otherRequire.validateSupplierForm())
        }
        await Promise.all(validateArray)
        return true
      } catch (e) {
        console.error('校验失败', e)
        this.$message.error('表单填写有误，请按照提示要求填写')
        return false
      }
    },

    /**
     * 获取未支付列表
     */
    async submit() {
      try {
        const { data } = await getUnpaidChargeListApi()
        if (data && data.length) {
          let showPay =
            data.length === 1 && data[0].tradeEmployeeId === this.employeeId
          if (
            data.length === 1 &&
            `${data[0].purchaseType}` ===
              `-${purchaseAllTypeDict.RECRUIT.value}`
          ) {
            showPay = true
          }
          Modal.confirm({
            title: '系统提示',
            icon: () =>
              this.$createElement('a-icon', {
                props: {
                  type: 'exclamation-circle',
                  theme: 'filled'
                }
              }),
            content: (
              <div>
                {showPay ? (
                  <p>
                    您参与的项目<strong>{data[0].orderName}</strong>
                    未完成支付服务费，请前往完成支付后参与项目
                  </p>
                ) : (
                  <p>
                    当前企业中{' '}
                    {data
                      .map(el => {
                        return `${
                          el.contactUserName
                        } 负责的项目 ${el.orderName || ''}`
                      })
                      .join('、')}
                    未完成支付服务费，请通知相关负责人完成支付服务费
                    {data.findIndex(
                      el =>
                        `${el.purchaseType}` ===
                        `-${purchaseAllTypeDict.RECRUIT.value}`
                    ) >= 0
                      ? ', 并到站内信完成服务费续费'
                      : ''}
                  </p>
                )}
              </div>
            ),
            cancelText: '取消',
            okText: showPay ? '支付' : '确认',
            onOk: () => {
              if (showPay) {
                if (
                  `${data[0].purchaseType}` ===
                  `-${purchaseAllTypeDict.RECRUIT.value}`
                ) {
                  window.open(
                    `${process.env.VUE_APP_PORTAL_URL}/project/pay/recruit-service?paymentId=${data[0].tradeId}&supplierId=${data[0].supplierId}`,
                    '_blank'
                  )
                } else {
                  this.$router.push({
                    name: purchaseAllTypeDict.translate(data[0].purchaseType)
                      ?.tradeRouterName,
                    params: {
                      orderId: data[0].orderId,
                      tradeId: data[0].tradeId
                    }
                  })
                }
              }
            }
          })
        } else {
          this.submitForm()
        }
      } catch (error) {
        this.$message.error(error?.message)
      }
    },

    // 提交信息
    async submitForm() {
      if (this.$refs.uploadFile && !this.$refs.uploadFile.uploadComplete()) {
        return false
      }
      try {
        const valid = await this.formValidate()
        if (!valid) return false
      } catch (e) {
        return false
      }

      let haveSomeCertUnUpload = false
      if (this.certRequireList.length > 0) {
        haveSomeCertUnUpload = this.certRequireList.some(
          item => !item.certAttachmentId
        )
      }
      if (haveSomeCertUnUpload) {
        this.$message.error('请按要求上传相关证件')
        return false
      }
      this.form.otherMaterialList = this.otherMaterialRequireList.map(item => {
        return {
          ...item,
          id: item.id,
          content:
            item.materialType === otherMaterialTypeDict.ATTACHMENT.value
              ? item.attachmentGroupId
              : item.textarea
        }
      })

      const { data } = await getDeviceIPApi()
      this.form.signUpIp = data || ''
      this.$emit('submit', this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
.application-submission {
  margin-bottom: 0px;
}
.card .section .section-title {
  margin-bottom: 0px;
}
.section {
  .section-title {
    &.border-bottom {
      border-bottom: 1px solid $dividing-color;
      padding-bottom: 20px;
    }
    .title-content {
      color: $text-color;
      font-size: 16px;
      display: flex;
      align-items: center;
      position: relative;
      padding-left: 10px;

      &::before {
        content: '';
        position: absolute;
        display: block;
        top: 5px;
        left: 0px;
        width: 4px;
        height: 16px;
        background-color: $primary-color;
      }
    }
  }

  // 区块内表单小标题
  .section-form-title {
    color: $second-text-color;
    padding: pixel-to-rem($n: 20) 0;
    border-bottom: 1px solid $border-color;
    font-size: pixel-to-rem($n: 20);
    line-height: 1;
  }
}

// 审核结果
.audit {
  margin-top: 16px;
  padding: 16px 24px;
  border-radius: 4px;
  margin-bottom: 10px;
  .audit-status {
    i {
      font-size: 20px;
      margin-right: 10px;
    }
    strong {
      font-size: 16px;
    }
  }
  .audit-content {
    margin-top: 9px;
    margin-left: 36px;
    font-size: 12px;
    color: $second-text-color;
  }
  &-success {
    border: 1px solid $success-second-color;
    background-color: $success-fourth-color;
  }
  &-danger {
    border: 1px solid $danger-second-color;
    background-color: $danger-fourth-color;
  }
  &-warning {
    border: 1px solid $warning-second-color;
    background-color: $warning-third-color;
  }
  &-primary {
    border: 1px solid $primary-second-color;
    background-color: $primary-third-color;
  }
}
.border-top {
  padding-top: 20px;
  border-top: 1px solid $dividing-color;
}
.operator-line {
  width: 100%;
  text-align: center;
  border-top: 1px solid $info-fourth-color;
  padding-top: 30px;
}
::v-deep {
  .el-form.detail-form .el-form-item .el-form-item__label {
    color: $text-color;
  }
  .el-form.detail-form .el-form-item .el-form-item__content {
    color: $second-text-color;
  }
}
</style>
